// import type { ActionReturn } from 'svelte/action';
// interface Attributes {
// 	'on:outsideclick': (e: CustomEvent<any>) => void;
// }
// export const clickOutside = (node: HTMLElement): ActionReturn<number, Attributes>  => {
// 	// the node has been mounted in the DOM
// 	window.addEventListener('click', handleClick);
// 	function handleClick(e: UIEvent){   
//   if (!node.contains(<Node>e.target)){
//     node.dispatchEvent(new CustomEvent('outsideclick'))
//   }
// }
// 	return {
// 		destroy() {
// 			// the node has been removed from the DOM
// 			window.removeEventListener('click', handleClick)
// 		}
// 	};
// } 
export function formReset(element /*,  options */) {
    let removeResetListener = () => {
        if (previousForm) {
            previousForm.removeEventListener('reset', handleReset);
        }
    };
    /**
     * @param {Event} event
     */
    function handleReset(event) {
        // `element.value` is only updated on the next frame
        requestAnimationFrame(() => {
            if (event.defaultPrevented)
                return;
            /**
             * Edge case: if disabled we don't want input handlers to fire
             * but we want the binding to know the value has been cleared out
             * `options.ignoreDisabled = true` is probably a more intuitive
             * default for binding
             */
            // if (element.disabled) return;
            element.dispatchEvent(new Event('input'));
        });
    }
    /**
     * Check the form on every update. The parent form can be changed using
     * the `form` attribute or if form is a `<svelte:element>` parent
     */
    let previousForm;
    function update() {
        const { form } = element;
        // remove listener from previous form in case the form changed
        if (!form)
            return removeResetListener();
        if (form === previousForm)
            return;
        // new form found, remove old listener
        removeResetListener();
        form.addEventListener('reset', handleReset);
        previousForm = form;
    }
    update();
    return {
        update,
        destroy() {
            removeResetListener();
        },
    };
}
function fixFormReset(element) {
    const form = element.form;
    if (!form)
        return;
    const handleReset = () => {
        // Set timeout is needed since `el.value` is only updated on the next frame
        setTimeout(() => {
            element.dispatchEvent(new Event('input'));
        }, 0);
    };
    form.addEventListener('reset', handleReset);
    return {
        destroy() {
            form.removeEventListener('reset', handleReset);
        }
    };
}
